import { Badge, Table, Text, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '../lib/format';
import { agentHolati, holatMatni, oxirgiAloqa, qisqaMatn, type AgentQator } from '../lib/agent';

/** Badge matni kesilmasin ("Aloqa yo'q — 3 soat" uzun) — QurilmaJadvali bilan bir xil. */
const BADGE_TOLIQ = { root: { overflow: 'visible', maxWidth: 'none' }, label: { overflow: 'visible', textOverflow: 'clip' } } as const;

type JadvalAgenti = AgentQator & { terminal?: { id: string; name: string }; tenant?: { id: string; name: string } | null };

/**
 * FACE ID agentlari jadvali — maktab FACE ID → Agentlar kartochkasi va superadmin "FACE ID agentlar"
 * sahifasi uchun BITTA joy (spec 2026-10-15 agent boshqaruv §6.2–6.3). Qator bosilsa `onTanla`
 * (yon oyna ochiladi). Tartib chaqiruvchida: maktabda server tartibi, superadminda `agentlarniSarala`.
 * `hozir` (server soati, `useServerSoati`) ham chaqiruvchidan: superadminda saralash va "Muammoli: N"
 * qator belgilari bilan aynan bir lahza bo'yicha hisoblansin.
 */
export function AgentJadvali({
  agentlar, hozir, onTanla, maktabUstuni = false,
}: {
  agentlar: JadvalAgenti[];
  /** Server soati bo'yicha "hozir" (ms) — `useServerSoati(dataUpdatedAt)`. */
  hozir: number;
  onTanla: (id: string) => void;
  maktabUstuni?: boolean;
}) {
  const { t } = useTranslation();
  const tt = (k: string, o?: { n: number }) => t(k, o);

  return (
    <Table.ScrollContainer minWidth={maktabUstuni ? 900 : 720}>
      {/* nowrap — telefonda ustunlar torayib belgilar kesilmasin, jadval yon tomonga suriladi */}
      <Table verticalSpacing="xs" highlightOnHover style={{ whiteSpace: 'nowrap' }}>
        <Table.Thead>
          <Table.Tr>
            {maktabUstuni && <Table.Th>{t('agent.colMaktab')}</Table.Th>}
            <Table.Th>{t('faceid.agentComputer')}</Table.Th>
            <Table.Th>{t('faceid.agentState')}</Table.Th>
            <Table.Th>{t('faceid.agentVersion')}</Table.Th>
            <Table.Th>{t('faceid.agentSeen')}</Table.Th>
            <Table.Th>{t('agent.oxirgiXato')}</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {agentlar.map((a) => {
            const h = agentHolati(a, hozir);
            const xato = a.holat?.oxirgiXato ?? null;
            return (
              <Table.Tr
                key={a.id}
                tabIndex={0}
                style={{ cursor: 'pointer' }}
                onClick={() => onTanla(a.id)}
                onKeyDown={(e) => { if (e.key === 'Enter') onTanla(a.id); }}
              >
                {maktabUstuni && (
                  <Table.Td>
                    <Text size="sm">{a.tenant?.name ?? '—'}</Text>
                    {a.terminal && <Text size="xs" c="dimmed">{a.terminal.name}</Text>}
                  </Table.Td>
                )}
                <Table.Td>
                  <Text size="sm" fw={500}>{a.name}</Text>
                  {a.ip && <Text size="xs" c="dimmed" ff="monospace">{a.ip}</Text>}
                </Table.Td>
                <Table.Td>
                  <Tooltip label={t('agent.eskiIzoh')} disabled={h.kalit !== 'eskiVersiya'} withArrow multiline w={260}>
                    <Badge color={h.rang} variant="light" styles={BADGE_TOLIQ}>{holatMatni(h, tt)}</Badge>
                  </Tooltip>
                </Table.Td>
                <Table.Td><Text size="xs" c="dimmed" ff="monospace">{a.version ?? '—'}</Text></Table.Td>
                <Table.Td><Text size="xs" c="dimmed">{formatDateTime(oxirgiAloqa(a))}</Text></Table.Td>
                <Table.Td>
                  {xato ? (
                    <Tooltip label={xato} withArrow multiline w={340} style={{ wordBreak: 'break-word' }}>
                      <Text size="xs" c="red">{qisqaMatn(xato, 40)}</Text>
                    </Tooltip>
                  ) : (
                    <Text size="xs" c="dimmed">—</Text>
                  )}
                </Table.Td>
              </Table.Tr>
            );
          })}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  );
}
